import type { Reducer } from 'redux';

import type { State } from './dealsTypes';
import { ActionType } from './dealsTypes';

export const initialState: State = {
  deals: {},

  isGettingListedDealsPage: false,
  listedDealsPage: null,

  isAddingDealAddress: false,
  isDealAddressAddedSuccessfully: undefined,

  isRemovingDealAddress: false,
  isDealAddressRemovedSuccessfully: undefined,
};

const dealsReducer: Reducer<State> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.REQUEST_GET_DEAL:
    case ActionType.REQUEST_UPDATE_DEAL: {
      const fetchedEntity = state.deals && state.deals[action.payload.dealId];

      return {
        ...state,
        deals: {
          ...state.deals,
          [action.payload.dealId]: {
            ...fetchedEntity,
            fetchAttemptedAttemptedAt: new Date(),
            fetchSucceededAt: undefined,
            fetchFailedAt: undefined,
            isFetching: true,
            fetchError: undefined,
          },
        },
      };
    }
    case ActionType.GET_DEAL_SUCCESS:
    case ActionType.UPDATE_DEAL_SUCCESS: {
      const fetchedEntity = state.deals && state.deals[action.payload.dealId];

      return {
        ...state,
        deals: {
          ...state.deals,
          [action.payload.dealId]: {
            ...fetchedEntity,
            entity: action.payload.deal,
            fetchSucceededAt: new Date(),
            isFetching: false,
          },
        },
      };
    }
    case ActionType.GET_DEAL_FAILURE:
    case ActionType.UPDATE_DEAL_FAILURE: {
      const fetchedEntity = state.deals && state.deals[action.payload.dealId];

      return {
        ...state,
        deals: {
          ...state.deals,
          [action.payload.dealId]: {
            ...fetchedEntity,
            fetchFailedAt: new Date(),
            isFetching: false,
            fetchError: action.error,
          },
        },
      };
    }
    case ActionType.CLEAR_DEALS: {
      return {
        ...initialState,
      };
    }

    case ActionType.REQUEST_GET_LISTED_DEALS_PAGE:
      return {
        ...state,
        isGettingListedDealsPage: true,
      };
    case ActionType.GET_LISTED_DEALS_PAGE_FAILURE:
      return {
        ...state,
        listedDealsPage: null,
        isGettingListedDealsPage: false,
      };
    case ActionType.GET_LISTED_DEALS_PAGE_SUCCESS:
      return {
        ...state,
        listedDealsPage: action.payload.listedDealsPage,
        isGettingListedDealsPage: false,
      };
    case ActionType.CLEAR_LISTED_DEALS_PAGE:
      return {
        ...state,
        listedDealsPage: null,
      };
    case ActionType.REQUEST_ADD_DEAL_ADDRESS:
      return {
        ...state,
        isAddingDealAddress: true,
        isDealAddressAddedSuccessfully: undefined,
      };
    case ActionType.ADD_DEAL_ADDRESS_SUCCESS:
      return {
        ...state,
        isAddingDealAddress: false,
        isDealAddressAddedSuccessfully: true,
      };
    case ActionType.ADD_DEAL_ADDRESS_FAILURE:
      return {
        ...state,
        isAddingDealAddress: false,
        isDealAddressAddedSuccessfully: false,
      };

    case ActionType.REQUEST_REMOVE_DEAL_ADDRESS:
      return {
        ...state,
        isRemovingDealAddress: true,
        isDealAddressRemovedSuccessfully: undefined,
      };
    case ActionType.REMOVE_DEAL_ADDRESS_SUCCESS:
      return {
        ...state,
        isRemovingDealAddress: false,
        isDealAddressRemovedSuccessfully: true,
      };
    case ActionType.REMOVE_DEAL_ADDRESS_FAILURE:
      return {
        ...state,
        isRemovingDealAddress: false,
        isDealAddressRemovedSuccessfully: false,
      };

    default:
      return state;
  }
};

export default dealsReducer;
